import { useXR, Controllers, Hands, useController } from "@react-three/xr";
import { Suspense } from "react";

import * as React from "react";

import { TourData, Scene } from "../../../Types";
import LoadingText from "./UI/LoadingText";
import CursorNew from "./UI/CursorNew";
import PopupsBackground from "./Popups/Open/PopupsBackground";
import Exit from "./UI/Exit";
import XRHotspots from "./Popups/XRHotspots";
import { Svg } from "@react-three/drei";
import { useDataRootStore } from "../../../api/Zustand";
import NavigationCheck from "./Popups/Open/NavigationCheck";

function XRSession(props: {
  currentScene: Scene;
  tourData: TourData;
  transition: boolean;
}) {
  const { currentScene, tourData, transition } = props;

  const session = useXR((state) => {
    return state.session;
  });

  const rightController = useController("right");
  const leftController = useController("left");
  const gazeController = useController("none");

  // KEY PRESS
  // console.log(rightController?.inputSource?.gamepad?.buttons[3].pressed);

  if (session) {
    return (
      <>
        <Controllers
          rayMaterial={{
            visible: !gazeController,
            depthTest: false,
            transparent: true,
            opacity: 0.85,
          }}
        />

        <Hands />

        {transition ? <LoadingText /> : <CursorNew />}

        <PopupsBackground currentScene={currentScene} />

        <Suspense>
          <NavigationCheck />
        </Suspense>

        <Suspense>
          <Exit TourData={tourData} />
        </Suspense>

        <Suspense>
          <XRHotspots
            currentScene={currentScene}
            tourData={tourData}
            transition={transition}
          ></XRHotspots>
        </Suspense>
      </>
    );
  }
  return null;
}

export default XRSession;
